import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { Flex } from '@mantine/core'

import { DashboardRoutePathsEnum } from '@/modules/dashboard/routes/dashboardRouteConfig.types'
import { LoginRoutePathsEnum } from '@/modules/login/routes/loginRouteConfig.types'

import { useUserStore } from '@/store/user.store'

export function FullWidthLayout() {
  const user = useUserStore.use.user()
  const location = useLocation()

  if (!user) {
    return (
      <Navigate state={{ from: location }} to={LoginRoutePathsEnum.LOGIN} />
    )
  }

  if (user.isOnboarded) {
    return (
      <Navigate
        state={{ from: location }}
        to={DashboardRoutePathsEnum.DASHBOARD}
      />
    )
  }

  return (
    <Flex align="center" direction="column" justify="flex-start">
      <Outlet />
    </Flex>
  )
}
